import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { Container, List } from '@pella/sash-framework';
import { Image } from '../../../';
import CTARibbon from '../../../common/cta-ribbon';
import SliderAndContent from '../slider-and-content';
import styles from './index.module.scss';
import { isValidArray } from '../../../utilities/validations';

const TabbedContent = ({ data, ...other }) => {
	const [activeTab, setActiveTab] = useState(0);

	const onTabClick = (index) => {
		let tabHeight = null;
		const active = document.getElementById(data.anchor_text);
		setActiveTab(index);

		if (active) {
			tabHeight = active.childNodes[0].offsetHeight;
		}

		if (active && tabHeight && window.scrollY < active.offsetTop + tabHeight) {
			window.scroll({
				top: active.offsetTop + tabHeight,
				left: 0,
				behavior: 'smooth',
			});
		}
	};

	const renderTabContent = (tab) => (
		<>
			{tab.carousel_icon?.file && (
				<Image
					data={{ image: tab.carousel_icon.file }}
					className={styles.imageTabs_TabImage}
					objectFit='contain'
				/>
			)}
			{tab.carousel_icon?.heading && <p className={styles.imageTabs_TabHeading}>{tab.carousel_icon.heading}</p>}
			{(tab.carousel_icon?.subheading || tab.carousel_icon?.heading_2) && <p className={styles.imageTabs_TabSubheading}>{tab.carousel_icon.subheading || tab.carousel_icon.heading_2}</p>}
		</>
	);

	if (!isValidArray(data?.product)) return null;

	return (
		<div
			id={data.anchor_text || null}
			className={styles.tabbedContent}
			{...other}
		>
			{isValidArray(data?.product) && (
				<div className={styles.imageTabs}>
					<Container width={1920}>
						{data.heading && <h2 className={styles.imageTabs_Heading}>{data.heading}</h2>}
						{data.description && (
							<div
								className={styles.imageTabs_Description}
								dangerouslySetInnerHTML={{
									__html: data.description,
								}}
							/>
						)}

						<List
							bullets='none'
							className={`${styles.imageTabs_List} ${data.product.length > 3 ? styles.imageTabs_List_large : ''}`}
						>
							{data.product.map((tab, index) => (
								<li key={index}>
									{!tab.carousel_icon?.linkable ? (
										<button
											onClick={() => onTabClick(index)}
											className={`${styles.imageTabs_TabButton} ${activeTab === index ? styles.imageTabs_TabButton_active : ''}`}
										>
											{renderTabContent(tab)}
										</button>
									) : (
										<Link
											to={tab.carousel_icon?.url}
											className={styles.imageTabs_TabButton}
										>
											{renderTabContent(tab)}
										</Link>
									)}
								</li>
							))}
						</List>
					</Container>
				</div>
			)}

			{data.product.map((product, index) => (
				<SliderAndContent
					key={index}
					data={product.group}
					isActive={activeTab === index}
				/>
			))}

			{data.cta_ribbon?.cta?.[0] && (
				<Container>
					<CTARibbon data={data.cta_ribbon.cta[0]} />
				</Container>
			)}
		</div>
	);
};

TabbedContent.propTypes = {
	data: PropTypes.object,
};

export default TabbedContent;
